module.exports = __webpack_public_path__ + "static/media/parier18.0237ed3d.png";